module.exports = __webpack_public_path__ + "img/voxicon-d27qo.d76514ee.jpg";